/* eslint-disable import/prefer-default-export */
import React from 'react';
import styles from './form-row.module.css';

interface TwoColumnFormRowProps {
    withMargin?: boolean;
    children?: React.ReactNode;
}

export const TwoColumnFormRow: React.FC<TwoColumnFormRowProps> = ({ withMargin = true, children }) => (
    <div className={styles.TwoColumnFormRow} style={{ margin: withMargin ? '0 0 1rem' : '0' }}>
        {children}
    </div>
);
